import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export interface SidemenuState {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
  sidebarWidth: number;
  setSidebarWidth: (width: number) => void;
}

const useSidemenuStore = create<SidemenuState>()(
  devtools(
    persist(
      (set) => ({
        isExpanded: true,
        setIsExpanded: (isExpanded: boolean) => set({ isExpanded }),
        sidebarWidth: 0,
        setSidebarWidth: (width: number) => set({ sidebarWidth: width }),
      }),
      {
        name: 'sidemenu-storage',
      },
    ),
  ),
);

export default useSidemenuStore;
